module.exports = __webpack_public_path__ + "img/business_Image_two.97e57b4a.png";